import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import { Toaster } from '@/components/ui/toaster'
import { ChatProvider } from '@/context/chat-context'
import { FloatingChat, ChatToggleButton } from '@/components/floating-chat'
import { GuideProposalBubble } from '@/components/guide-assistant'
import { useAuth } from '@/stores/authStore'
import GeneralError from '@/views/errors/general-error'
import NotFoundError from '@/views/errors/not-found-error'
import { AnnouncementModal } from '@/components/notifications/announcement-modal'

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  component: () => {
    const { user } = useAuth()
    const isAuthenticated = !!user

    return (
      <ChatProvider>
        <Outlet />
        <Toaster />
        {isAuthenticated && (
          <>
            <ChatToggleButton />
            <FloatingChat />
            <GuideProposalBubble />
            <AnnouncementModal />
          </>
        )}
        {import.meta.env.MODE === 'development' && (
          <>
            {/*             <ReactQueryDevtools buttonPosition='bottom-left' />
            <TanStackRouterDevtools position='bottom-right' /> */}
          </>
        )}
      </ChatProvider>
    )
  },
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
})
